module.exports = __webpack_public_path__ + "open1-e7d4d7bceabd3ae8a47b6646f73fbaf5.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/options/open1.png
// module id = 480
// module chunks = 0